'use es6';

export default Object.freeze({
  JS_ASSETS: 'jsAssets',
  CSS_ASSETS: 'cssAssets',
  GRAPHQL_ASSETS: 'graphqlAssets',
  OTHER_ASSETS: 'otherAssets'
});